module.exports = __webpack_public_path__ + "img/3-1-4.91481b9e.png";